<script setup>

import AvatarBadge from "@/components/AvatarBadge.vue";
import Button from "@/components/Button.vue";

defineProps({
  user: { type: Object, required: true },
  showActionBtn: { type: Boolean, default: false },
  actionBtn: Function
})
</script>

<template>
  <div class="d-flex justify-content-between align-items-center mb-2">
    <div class="d-flex align-items-center">
      <AvatarBadge class="symbol-40px" :fullname="user.participator.fullname" :avatar-url="user.participator.avatar_url" />
      <span class="ms-3"> {{ user.participator.fullname }} </span>
    </div>
    <Button v-if="showActionBtn" btn-class="btn-sm" type="new" background-color="red"  iconClass="fa fa-trash" @click.prevent="actionBtn" />
  </div>
</template>

<style scoped>

</style>